import { HTML_LINK_TARGET } from '../../../constants/html'
import { useInitData, useLinkLikeClick } from '../../../hooks'
import { stopPropagation } from '../../../utils/events'
import { getRequestProfilePathname } from '../../../utils/link'
import { MultiValuedList } from '../../MultiValuedList'

import { RequestMultiValuedListItem } from './RequestMultiValuedListItem'
import { RequestMultiValuedListMore } from './RequestMultiValuedListMore'
import { RequestMultiValuedListMoreItem } from './RequestMultiValuedListMoreItem'

import * as styles from './RequestMultiValuedList.module.css'

function RequestMultiValuedList({
  Item = RequestMultiValuedListItem,
  More = RequestMultiValuedListMore,
  MoreItem = RequestMultiValuedListMoreItem,
  className = styles.RequestMultiValuedList,
  moreItemsProps,
  moreProps,
  size,
  onClickItem,
  onClickMoreItem,
  ...restProps
}) {
  const { handleClick, handleMouseDown } = useLinkLikeClick()

  const { availableSections } = useInitData()

  function handleClickItem(id, event) {
    handleClick({
      event,
      link: getRequestProfilePathname({ availableSections, id }),
      target: HTML_LINK_TARGET.blank,
    })
  }

  function handleMouseDownItem(id, event) {
    stopPropagation(event)

    handleMouseDown({
      event,
      link: getRequestProfilePathname({ availableSections, id }),
    })
  }

  return (
    <MultiValuedList
      {...restProps}
      Item={Item}
      More={More}
      MoreItem={MoreItem}
      className={className}
      moreItemsProps={{
        ...moreItemsProps,
        onClickItem: onClickMoreItem || handleClickItem,
        onMouseDownItem: handleMouseDownItem,
      }}
      moreProps={moreProps}
      size={size}
      onClickItem={onClickItem || handleClickItem}
      onMouseDownItem={handleMouseDownItem}
    />
  )
}

export default RequestMultiValuedList
